import { render } from "./ViewAdminReservas.vue?vue&type=template&id=1e02d152&scoped=true"
import script from "./ViewAdminReservas.vue?vue&type=script&lang=js"
export * from "./ViewAdminReservas.vue?vue&type=script&lang=js"

import "./ViewAdminReservas.vue?vue&type=style&index=0&id=1e02d152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e02d152"]])

export default __exports__